import { generateID } from '@caresend/utils';

const initialValueIsArray = (files, multiple) => {
    const filesIsArray = Array.isArray(files);
    if (multiple && !filesIsArray) {
        throw new Error('Expected array of files when multiple prop set to true.');
    }
    if (!multiple && filesIsArray) {
        throw new Error('Expected single file when multiple prop set to false.');
    }
    return filesIsArray;
};
/** Takes a URL and extracts the file name, remove anchor tags and query
 * strings. URL escapes are decoded to ensure compatibility with Cloud
 * Storage URLS */
const extractFileNameFromURL = (url) => {
    var _a, _b, _c;
    return (_c = (_b = (_a = decodeURIComponent(url)
        .split('/')
        .pop()) === null || _a === void 0 ? void 0 : _a.split('#')[0]) === null || _b === void 0 ? void 0 : _b.split('?')[0]) !== null && _c !== void 0 ? _c : 'Uploaded File';
};
/** Builds an `UploadedFile` object from an unencrypted URL. */
const urlToUploadedFile = (url, markAsPDF, encryptedFile) => {
    var _a;
    const fileName = (_a = encryptedFile === null || encryptedFile === void 0 ? void 0 : encryptedFile.metadata.fileName) !== null && _a !== void 0 ? _a : extractFileNameFromURL(url);
    return {
        encryptedFile,
        fileName,
        isPDF: markAsPDF !== null && markAsPDF !== void 0 ? markAsPDF : false,
        localID: generateID(),
        url,
    };
};
/** Encryption type guard for one `props.initialValue` file */
const isEncryptedFile = (file) => typeof file === 'object' && file.encryptedFile;
/** Encryption type guard for multiple `props.initialValue` files */
const isEncryptedFiles = (files) => !!files[0] && isEncryptedFile(files[0]);
/** Builds an array of `UploadedFile` objects from an array of unencrypted URLs. */
const urlsToUploadedFiles = (urls) => urls.map((url) => urlToUploadedFile(url));
/** Builds an `UploadedFile` object for an encrypted file that has yet to be
     * decrypted. */
const getLoadingEncryptedFile = (file) => ({
    encryptedFile: file,
    fileName: file.metadata.fileName,
    isPDF: file.metadata.contentType === 'application/pdf',
    localID: generateID(),
});
/** Builds an initial array of `UploadedFile` objects based on the passed in
 * `props.initialValue`. */
const filePickerValueToUploadedFiles = (value, multiple) => {
    const initialFileOrFiles = value;
    if (!initialFileOrFiles)
        return [];
    if (multiple && initialValueIsArray(initialFileOrFiles, multiple)) {
        if (isEncryptedFiles(initialFileOrFiles)) {
            return initialFileOrFiles.map((file) => getLoadingEncryptedFile(file));
        }
        return urlsToUploadedFiles(initialFileOrFiles);
    }
    if (initialValueIsArray(initialFileOrFiles, multiple))
        return [];
    if (isEncryptedFile(initialFileOrFiles)) {
        return [getLoadingEncryptedFile(initialFileOrFiles)];
    }
    return [urlToUploadedFile(initialFileOrFiles)];
};

export { filePickerValueToUploadedFiles, initialValueIsArray, isEncryptedFile, urlToUploadedFile };
